// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qlWxJmwFrCgy1Bo6GmmF{align-items:center;gap:10px;width:100%;padding:12px 20px 16px;display:flex}.qlWxJmwFrCgy1Bo6GmmF .ZOuSh762Kq44VZDGRKWX{align-items:center;width:100%}.qlWxJmwFrCgy1Bo6GmmF .ZOuSh762Kq44VZDGRKWX>input{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:150%}.qlWxJmwFrCgy1Bo6GmmF .ZOuSh762Kq44VZDGRKWX>input ::placeholder{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `qlWxJmwFrCgy1Bo6GmmF`,
	"search": `ZOuSh762Kq44VZDGRKWX`
};
export default ___CSS_LOADER_EXPORT___;
